import { render } from "./JoinUs.vue?vue&type=template&id=9029ba8a&scoped=true"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"

import "./JoinUs.vue?vue&type=style&index=0&id=9029ba8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9029ba8a"]])

export default __exports__